import { useNavigate } from "react-router-dom";

export function SearchResults({ results, onClose }) {
  const nav = useNavigate();
  const { devices, apps, tutorials, faqs } = results;
  const empty = !devices.length && !apps.length && !tutorials.length && !faqs.length;
  const go = (to) => { nav(to); onClose(); };
  return (
    <div data-testid="search-results" className="absolute z-[55] mt-2 w-full p-4 max-h-[420px] overflow-y-auto rounded-2xl border border-cyan-400/25 shadow-2xl" style={{ background: "#0E1420" }}>
      {empty && <div className="text-sm text-gray-400 py-6 text-center">Nada encontrado. Tente outra palavra ou fale no WhatsApp.</div>}
      {devices.length > 0 && <Group title="Dispositivos">
        {devices.map((d) => <Row key={d.id} onClick={() => go(`/dispositivos/${d.slug}`)} label={d.name} sub={d.description} testid={`search-device-${d.slug}`} />)}
      </Group>}
      {tutorials.length > 0 && <Group title="Tutoriais">
        {tutorials.map((t) => <Row key={t.id} onClick={() => go(`/tutorial/${t.slug}`)} label={t.title} sub={`${t.category} · ${t.time_estimate}`} testid={`search-tutorial-${t.slug}`} />)}
      </Group>}
      {apps.length > 0 && <Group title="Aplicativos">
        {apps.map((a) => <Row key={a.id} onClick={() => go("/aplicativos")} label={a.name} sub={a.platforms.join(", ")} testid={`search-app-${a.name}`} />)}
      </Group>}
      {faqs.length > 0 && <Group title="Perguntas Frequentes">
        {faqs.map((f) => <Row key={f.id} onClick={() => go("/faq")} label={f.question} testid={`search-faq-${f.id}`} />)}
      </Group>}
    </div>
  );
}

function Group({ title, children }) {
  return <div className="mb-3 last:mb-0"><div className="text-xs font-semibold uppercase tracking-widest text-amber-400 mb-1.5 px-1">{title}</div><div>{children}</div></div>;
}

function Row({ label, sub, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid} className="w-full text-left px-3 py-2 rounded-lg hover:bg-white/5 transition">
      <div className="text-sm font-medium">{label}</div>
      {sub && <div className="text-xs text-gray-500">{sub}</div>}
    </button>
  );
}

export function StatusMini({ s }) {
  const map = { online: ["🟢", "text-emerald-400"], maintenance: ["🟡", "text-amber-400"], instability: ["🔴", "text-red-400"] };
  const [dot, color] = map[s.status] || map.online;
  return (
    <div className="ci-card p-4">
      <div className="flex items-center gap-2"><span>{dot}</span><span className="font-semibold text-sm">{s.name}</span></div>
      <div className={`text-xs mt-1 ${color}`}>{s.message}</div>
    </div>
  );
}
